<template>
    <table class="table table-sm bordered-header">
        <thead>
            <tr>
                <th class="w-25 text-nowrap">Başlangıç Tarihi</th>
                <th class="w-25 text-nowrap">Bitiş Tarihi</th>
                <th class="w-25 text-nowrap">Gün</th>
                <th class="w-25 text-nowrap">Kullanım Tipi</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(v,i) in (value || [])" :key="i">
                <td>{{ $safe(v,'StartDateStr') || '' }}</td>
                <td>{{ $safe(v,'EndDateStr') || '' }}</td>
                <td>{{ $safe(v,'Days') || '' }}</td>
                <td>{{ $safe(v,'Type') || '' }}</td>
            </tr>
            <tr v-if="totalUsed >= 0 && (value || []).length > 0">
                <td colspan="2" class="text-right">Toplam</td>
                <td colspan="2" class="text-left">{{ totalUsed }}</td>
            </tr>
            <tr v-if="(value || []).length == 0">
                <td colspan="2" class="text-center">Henüz bir yıllık izin kullanılmamıştır.</td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props:{
        totalUsed:{
            default:0,
            type:Number
        },
        value:Array
    }
}
</script>